import { Box, styled } from '@mui/material';

export const Wrapper = styled(Box, {
	shouldForwardProp: (prop) => prop !== 'disabled',
})<{ disabled?: boolean }>(({ theme, disabled = false }) => ({
	display: 'flex',
	flexDirection: 'column',
	border: '1px solid rgba(0, 0, 0, 0.23)',
	borderRadius: theme.shape.borderRadius,
	padding: '16px',

	...(disabled && {
		opacity: 0.6,
		pointerEvents: 'none',
	}),
}));

export const FileUploadWrap = styled(Box, {
	shouldForwardProp: (prop) => prop !== 'isDragOver' && prop !== 'isError',
})(
	({ isDragOver, isError }: { isDragOver: boolean; isError: boolean }) => ({
		position: 'relative',
		height: '100%',
		flex: 1,
		marginBottom: '1rem',
		width: '100%',
		borderRadius: '1rem',
		overflow: 'hidden',
		padding: '0.5rem',
		border: '1px dashed rgba(0, 0, 0, 0.23)',
		display: 'flex',
		justifyContent: 'center',
		flexDirection: 'column',
		alignItems: 'center',
		minHeight: '180px',
		cursor: 'pointer',
		'@media (min-width: 1024px)': {
			borderRadius: '1.5rem',
		},
		...(isDragOver && {
			boxShadow: 'inset 0 0 0 1px rgba(13, 42, 148, 0.25)',
		}),
		...(isError && { borderColor: 'red' }),
	}),
);

export const FileUploadInsideWrap = styled('div')({
	height: '100%',
	width: '100%',
	display: 'flex',
	flex: 1,
	flexDirection: 'column',
	alignItems: 'center',
	justifyContent: 'center',
});

export const FileUploadText = styled('p')({
	margin: '0 0 12px 0',
});

export const FileUploadFormatsText = styled('p')({
	margin: '0',
	fontSize: '14px',
	whiteSpace: 'pre',
});

export const FileUploadTextPrimary = styled('span')(({ theme }) => ({
	color: theme.palette.primary.main,
	cursor: 'pointer',
}));

export const FileUploadErrortext = styled('p')({
	color: 'red',
	margin: 0,
});

export const FileUploadImage = styled('img')({
	display: 'flex',
	height: '100%',
	maxWidth: '100%',
	maxHeight: '400px',
	objectFit: 'contain',
	objectPosition: 'center',
});
